module.exports = __webpack_public_path__ + "static/media/did the sun explode.125fbae1.png";